import { useSyncExternalStore } from "react";

// Globální přepínač zobrazení cen na webu: "incl" = hlavní cena s DPH, "excl" = hlavní cena bez DPH.
const KEY = "ed_vat_mode";
const listeners = new Set();

export const getVatMode = () => {
  try { return localStorage.getItem(KEY) === "excl" ? "excl" : "incl"; } catch { return "incl"; }
};
export const setVatMode = (m) => {
  try { localStorage.setItem(KEY, m === "excl" ? "excl" : "incl"); } catch { /* ignore */ }
  listeners.forEach((l) => l());
};
const subscribe = (l) => { listeners.add(l); return () => listeners.delete(l); };

export const useVatMode = () => useSyncExternalStore(subscribe, getVatMode, () => "incl");
